import {
  INVENTORY,
  KEY_TILES_MAP,
  LOCK_AND_KEY_COLORS,
  PLACEMENT_TYPE_HERO,
} from "../helpers/consts";
import { Placement } from "./Placement";
import { SFX } from "../classes/Sounds";
import Sprite from "../components/object-graphics/Sprite";
import { TILES } from "../helpers/tiles";

export class LockPlacement extends Placement {
  constructor(properties, level) {
    super(properties, level);
    this.color = properties.color ?? LOCK_AND_KEY_COLORS.BLUE;
    this.collectInFrames = 0;
  }

  playSfxOnCollect() {
    return SFX.UNLOCK;
  }

  isSolid(body) {
    // If collected, placement is Invisible and shouldn't be solid
    if (this.hasBeenCollected) {
      return false;
    }
    return true;
  }

  isLockThatCanBeOpened() {
    if (
      !this.hasBeenCollected &&
      this.color === LOCK_AND_KEY_COLORS.BLUE &&
      this.level.inventory.has(INVENTORY.BLUE_KEY_PICKUP)
    ) {
      return true;
    }
    if (
      !this.hasBeenCollected &&
      this.color === LOCK_AND_KEY_COLORS.GREEN &&
      this.level.inventory.has(INVENTORY.GREEN_KEY_PICKUP)
    ) {
      return true;
    }
    return false;
  }

  unlock() {
    //Start counting
    this.collectInFrames = 11;
  }

  tick() {
    if (this.collectInFrames > 0) {
      this.collectInFrames -= 1;
      if (this.collectInFrames === 0) {
        this.hasBeenCollected = true;
      }
    }
  }

  addsItemToInventoryOnCollide(body) {
    if (body.type === PLACEMENT_TYPE_HERO) {
      return `lock_${this.color}`;
    }
    return null;
  }

  renderComponent() {
    let frame = KEY_TILES_MAP[this.color].LOCK;
    if (this.collectInFrames > 0) {
      frame = TILES.UNLOCKED_LOCK;
    }

    return <Sprite frameCoord={frame} />;
  }
}
